
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/faqs",
      function () {
        return require("private-next-pages/company/faqs/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company/faqs"])
      });
    }
  